import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import properties from '../../../modules/ajio-util/properties';

class Productmodel extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const prodData = this.props.data;
    let SizeWornByModel = '';
    let ModelChestSize = '';
    let ModelHeight = '';
    let ModelWaistSize = '';
    let { shopTheLook = {} } = this.props;
    let { products = [], ensembleLongTitle = '' } = shopTheLook;
    return (
      <div className="model-size">
        {prodData &&
          prodData.map((list, i) =>
            list.featureValues.map((sublist, j) => {
              if (list.name === 'Size worn by Model' && sublist.value) {
                SizeWornByModel = sublist.value;
              }
              if (list.name === 'Model Chest Size' && sublist.value) {
                ModelChestSize = sublist.value;
              }
              if (list.name === 'Model Height' && sublist.value) {
                ModelHeight = sublist.value;
              }
              if (list.name === 'Model Waist Size' && sublist.value) {
                ModelWaistSize = sublist.value;
              }
            })
          )}
        {
          <div>
            {SizeWornByModel && (
              <div>
                {SizeWornByModel && <span>Our model wears a Size {SizeWornByModel}</span>}
                {(ModelHeight || ModelChestSize || ModelWaistSize) && <span>,&nbsp;with</span>}
                {ModelHeight && <span>&nbsp;Height {ModelHeight} </span>}
                {ModelChestSize ? (
                  ModelChestSize && ModelWaistSize ? (
                    <span>,&nbsp;Chest {ModelChestSize}</span>
                  ) : (
                    <span>and&nbsp;Chest {ModelChestSize}</span>
                  )
                ) : (
                  ''
                )}
                {ModelWaistSize ? <span>and&nbsp;Waist {ModelWaistSize}</span> : ''}
              </div>
            )}
          </div>
        }
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { activePincode, eddDetails = {} } = state.edd;
  return {
    shopTheLook: state.product.ensamble,
    eddDetailsForProductDetails: eddDetails[activePincode] || {}
  };
}
export default withRouter(connect(mapStateToProps)(Productmodel));
